/* eslint-disable import/no-cycle */
import { call, put, takeEvery } from 'redux-saga/effects';
import { displayLoading, displaySuccess } from '../../utils/toast/Toast';
import { commands } from '../../api/api';
import {
  SEARCH_COMMANDS,
  SEARCH_COMMANDS_SUCCESS,
  SEARCH_COMMANDS_FAILURE,
  GET_COMMAND,
  GET_COMMAND_SUCCESS,
  GET_COMMAND_FAILURE,
  UPDATE_COMMAND_OFFER,
  UPDATE_COMMAND_OFFER_SUCCESS,
  UPDATE_COMMAND_OFFER_FAILURE,
  UPDATE_COMMAND,
  UPDATE_COMMAND_SUCCESS,
  UPDATE_COMMAND_FAILURE,
  UPDATE_ITEMS,
  UPDATE_ITEMS_SUCCESS,
  UPDATE_ITEMS_FAILURE,
  CANCEL_COMMAND,
  CANCEL_COMMAND_SUCCESS,
  CANCEL_COMMAND_FAILURE,
  UPDATE_COMMAND_ADDRESS,
  UPDATE_COMMAND_ADDRESS_SUCCESS,
  UPDATE_COMMAND_ADDRESS_FAILURE,
  GET_RETURN_LABEL,
  GET_RETURN_LABEL_SUCCESS,
  GET_RETURN_LABEL_FAILURE,
  DUPLICATE_COMMAND_SUCCESS,
  DUPLICATE_COMMAND_FAILURE,
  DUPLICATE_COMMAND
} from './commandsActions';

import logger from '../../utils/logger';

/**
 * Récupération de plusieurs commandes
 * @param  {Object}    action action object
 */
export function* searchCommands(action) {
  try {
    const params = action.payload;
    if (!params.states.length) {
      params.states = undefined;
    }
    const response = yield call(commands.search, params);
    if (response.data.success === true) {
      yield put({ type: SEARCH_COMMANDS_SUCCESS, payload: response.data });
    } else {
      yield put({ type: SEARCH_COMMANDS_FAILURE });
    }
  } catch (error) {
    logger(error);
    yield put({ type: SEARCH_COMMANDS_FAILURE });
  }
}

/**
 * Récupération d'une seul commande
 * @param  {Object}    action action object
 */
export function* getCommand(action) {
  try {
    const response = yield call(commands.getCommand, action.payload);
    if (response.data.success === true) {
      yield put({ type: GET_COMMAND_SUCCESS, payload: response.data });
    } else {
      yield put({ type: GET_COMMAND_FAILURE });
    }
  } catch (error) {
    logger(error);
    yield put({ type: GET_COMMAND_FAILURE });
  }
}

/**
 * Mise à jour d'une seul commande
 * @param  {Object}    action action object
 */
export function* updateCommand(action) {
  const closeLoading = displayLoading(`Mise à jour en cours`);
  try {
    const response = yield call(commands.updateCommand, action.payload);
    if (response.data.success === true) {
      yield put({ type: UPDATE_COMMAND_SUCCESS, payload: response.data });
      displaySuccess('Commande mise à jour');
    }
  } catch (error) {
    logger(error);
    yield put({ type: UPDATE_COMMAND_FAILURE });
  } finally {
    closeLoading();
  }
}

/**
 * Mise à jour des items d'une commande
 * @param  {Object}    action action object
 */
export function* updateItems(action) {
  const closeLoading = displayLoading(`Mise à jour en cours`);
  try {
    const response = yield call(commands.updateItems, action.payload);
    if (response.data.success === true) {
      yield put({ type: UPDATE_ITEMS_SUCCESS, payload: response.data });
      displaySuccess('Commande mise à jour');
    }
  } catch (error) {
    logger(error);
    yield put({ type: UPDATE_ITEMS_FAILURE });
  } finally {
    closeLoading();
  }
}

/**
 * Mise à jour de l'adressse d'une seul commande
 * @param  {Object}    action action object
 */
export function* updateCommandAddress(action) {
  const closeLoading = displayLoading(`Mise à jour en cours`);
  try {
    const response = yield call(commands.updateAddress, action.payload);
    if (response.data.success === true) {
      yield put({
        type: UPDATE_COMMAND_ADDRESS_SUCCESS,
        payload: response.data
      });
      displaySuccess('Commande mise à jour');
    }
  } catch (error) {
    logger(error);
    yield put({ type: UPDATE_COMMAND_ADDRESS_FAILURE });
  } finally {
    closeLoading();
  }
}

/**
 * Mise à jour de l'offre d'une seul commande
 * @param  {Object}    action action object
 */
export function* updateCommandoffer(action) {
  const closeLoading = displayLoading(`Mise à jour en cours`);
  try {
    const response = yield call(commands.updateOffer, action.payload);
    if (response.data.success === true) {
      yield put({
        type: UPDATE_COMMAND_OFFER_SUCCESS,
        payload: response.data
      });
    }
    const commandResponse = yield call(
      commands.getCommand,
      action.payload.commandId
    );
    if (commandResponse.data.success === true) {
      yield put({ type: GET_COMMAND_SUCCESS, payload: commandResponse.data });
      displaySuccess('Commande mise à jour');
    } else {
      yield put({ type: GET_COMMAND_FAILURE });
    }
  } catch (error) {
    logger(error);
    yield put({ type: UPDATE_COMMAND_OFFER_FAILURE });
  } finally {
    closeLoading();
  }
}

/**
 * Annulation d'une commande
 * @param  {Object}    action action object
 */
export function* cancelCommand(action) {
  const closeLoading = displayLoading(`Annulation de la commande en cours`);
  try {
    const response = yield call(commands.cancel, action.payload);
    if (response.data.success === true) {
      yield put({ type: CANCEL_COMMAND_SUCCESS });
      displaySuccess('Commande annulée avec succès');
    }
  } catch (error) {
    logger(error);
    yield put({ type: CANCEL_COMMAND_FAILURE });
  } finally {
    closeLoading();
  }
}

/**
 * Récupération d'un bon de retour
 * @param  {Object}  action action object
 */
export function* getReturnLabel(action) {
  const closeLoading = displayLoading(
    `Génération de l'étiquette de retour en cours`
  );
  try {
    const response = yield call(commands.generateReturnLabel, action.payload);
    if (response.data.success === true) {
      yield put({ type: GET_RETURN_LABEL_SUCCESS, payload: response.data });
      displaySuccess('Étiquette de retour généré avec succès');
    }
  } catch (error) {
    logger(error);
    yield put({ type: GET_RETURN_LABEL_FAILURE });
  } finally {
    closeLoading();
  }
}

/**
 * Duplication d'une commande
 * @param  {Object}    action action object
 */
export function* duplicateCommand(action) {
  const closeLoading = displayLoading(`Duplication de la commande en cours`);
  try {
    const response = yield call(commands.duplicateCommand, action.payload);
    if (response.data.success === true) {
      yield put({ type: DUPLICATE_COMMAND_SUCCESS });
      displaySuccess('Commande dupliquée avec succès');
    }
  } catch (error) {
    logger(error);
    yield put({ type: DUPLICATE_COMMAND_FAILURE });
  } finally {
    closeLoading();
  }
}

const signinSaga = [
  takeEvery(SEARCH_COMMANDS, searchCommands),
  takeEvery(GET_COMMAND, getCommand),
  takeEvery(DUPLICATE_COMMAND, duplicateCommand),
  takeEvery(UPDATE_COMMAND, updateCommand),
  takeEvery(UPDATE_ITEMS, updateItems),
  takeEvery(CANCEL_COMMAND, cancelCommand),
  takeEvery(UPDATE_COMMAND_ADDRESS, updateCommandAddress),
  takeEvery(UPDATE_COMMAND_OFFER, updateCommandoffer),
  takeEvery(GET_RETURN_LABEL, getReturnLabel)
];

export default signinSaga;
